module.exports = __webpack_public_path__ + "img/link-icon.5e463764.svg";